import {
  serviceBase,
  massOperation,
  createErrorMessage,
  createSuccessMessage
} from "../service";
import api from "../api";

const Contacts = {
  ...serviceBase,
  resource: "contacts",
  copy: massOperation("copy"),
  move: massOperation("move"),
  users: {
    get: function(params = {}, onSuccess = () => {}) {
      let { id, ...paramsWithOutId } = params;
      return api
        .get(`/contacts/${id}/users`, paramsWithOutId)
        .then(res => {
          onSuccess(res.data.items);
        })
        .catch(res => createErrorMessage(res));
    },
    add: function(params = {}, onSuccess = () => {}) {
      let { id, ...paramsWithOutId } = params;
      return api
        .put(`/contacts/${id}/users`, paramsWithOutId)
        .then(() => {
          createSuccessMessage("add");
          onSuccess();
        })
        .catch(res => createErrorMessage(res));
    },
    delete: function(params = {}, onSuccess = () => {}) {
      let { id, user_id, ...paramsWithOutId } = params;
      return api
        .delete(`/contacts/${id}/users/${user_id}`, paramsWithOutId)
        .then(() => {
          createSuccessMessage("delete");
          onSuccess();
        })
        .catch(res => createErrorMessage(res));
    }
  }
};
export default Contacts;
